"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabGroup = exports.TabItem = void 0;
var react_1 = require("react");
var jsx_runtime_1 = require("react/jsx-runtime");
var react_2 = require("react");
var Icon_1 = require("./Icon");
//--------Tab Item-------//
var TabContainerBaseClass = function (active, leftIcon, rightIcon, type) {
    return type === 'pill'
        ? "\n    ".concat(active ? 'bg-alias-color-bg-accent' : 'bg-alias-color-bg-none', "\n    ").concat(!active && 'hover:bg-alias-state-base-hover', "\n    ").concat(!active && "active:bg-alias-state-base-pressed" /* pressed state */, "\n    ").concat(active
            ? 'text-alias-color-text-on-accent'
            : 'text-alias-color-text-weakest', "\n    ").concat(leftIcon
            ? 'pl-component-tab-padding-tight'
            : 'pl-component-tab-padding-base', "\n    ").concat(rightIcon
            ? 'pr-component-tab-padding-tight'
            : 'pr-component-tab-padding-base', "\n    rounded-component-tab-border-radius\n    flex\n    items-center\n    gap-component-tab-space\n    h-component-tab-height\n    font-alias-font-lable-strong  \n  ")
        : "\n  ".concat(
        //note that border-width is not working with tokens.
        active ? 'border-b-[2px]' : 'border-b-[1px]', "\n  ").concat(active
            ? 'border-alias-color-border-active'
            : 'border-alias-color-border-base', "\n  ").concat(!active &&
            "\n    hover:border-alias-color-border-hover\n    active:border-alias-color-border-pressed\n    hover:border-b-[2px]\n    active:border-b-[2px]\n    ", "\n  ").concat(active ? 'text-alias-color-text-on-accent' : 'text-alias-color-text-weakest', "\n  ").concat(leftIcon
            ? 'pl-component-tab-padding-tight'
            : 'pl-component-tab-padding-base', "\n  ").concat(rightIcon
            ? 'pr-component-tab-padding-tight'
            : 'pr-component-tab-padding-base', "\n  flex\n  items-center\n  gap-component-tab-space\n  h-component-tab-height\n  font-alias-font-lable-strong  \n");
};
var TabItem = function (props) {
    var label = props.label, id = props.id, type = props.type, active = props.active, onClick = props.onClick, leftIcon = props.leftIcon, rightIcon = props.rightIcon, dataTestID = props["data-testid"];
    var tabClick = function () {
        onClick && onClick(id);
    };
    return ((0, jsx_runtime_1.jsxs)("button", __assign({ className: TabContainerBaseClass(!!active, !!leftIcon, !!rightIcon, type), onClick: tabClick, role: "tab", "aria-selected": active, "data-testid": dataTestID }, { children: [leftIcon && (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: leftIcon }), (0, jsx_runtime_1.jsx)("span", { children: label }), rightIcon && (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: rightIcon })] })));
};
exports.TabItem = TabItem;
//--------Tab Group--------//
var TabGroupBaseClasses = function (type) {
    return "\n  flex\n  ".concat(type === 'pill'
        ? 'gap-components-tab-group-space-pill'
        : 'gap-components-tab-group-space-border', "\n  ");
};
/** Tab Group
 * @param {TabItemProps[]} tabs TabItemProps to be used
 * @param {'pill' | 'border'} type display style: pill or border
 * @returns {React.FC} TabGroup element
 */
var TabGroup = function (props) {
    var tabs = props.tabs, type = props.type, dataTestID = props["data-testid"];
    var _a = (0, react_2.useState)(tabs[0].id), activeTab = _a[0], setActiveTab = _a[1];
    var tabItemClick = function (id) {
        setActiveTab(id);
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: TabGroupBaseClasses(type), role: "tablist", "data-testid": dataTestID }, { children: tabs.map(function (tabProps) {
            return ((0, react_1.createElement)(exports.TabItem, __assign({}, tabProps, { onClick: tabItemClick, active: activeTab === tabProps.id, type: type, key: tabProps.id })));
        }) })));
};
exports.TabGroup = TabGroup;
